import { sortWithConvertingToNumber } from "./sortWithConvertingToNumber";
import { sortWithCreatedBy } from "./sortWithCreatedBy";
import { sortWithUnusedSince } from "./sortWithUnusedSince";
import { sortWithState } from "./sortWithState";

export const sortingFns = {
  sortWithConvertingToNumber,
  sortWithCreatedBy,
  sortWithUnusedSince,
  sortWithState,
};
